/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-02 17:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React, { Component } from 'react';
import { Card, Layout, Caption, TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { connect } from 'react-redux';

import { URL } from 'src/constants/links';
import knowledgeBase01 from 'src/assets/images/dashboard/knowledgebase1_01.png';
import knowledgeBase02 from 'src/assets/images/dashboard/knowledgebase1_02.png';
import knowledgeBase03 from 'src/assets/images/dashboard/knowledgebase1_03.png';

import withBlockCanDismiss from './blockCanDismiss';
import YoutubeModal from 'src/components/views/common/youtube-modal';

type Props = {
  renderPopover: () => void,
  knowledgeGuide: Object
};

type ComposedProps = Props & WithI18nProps;

type State = {
  youtubeModal: Object
};

class GuideToKnowledgeBase extends Component<ComposedProps, State> {
  state = {
    youtubeModal: null
  };
  render() {
    const { youtubeModal } = this.state;
    const { renderPopover, i18n, knowledgeGuide } = this.props;

    const {
      contents = [
        {
          articleTitle: 'What’s new with Boost Product Filter & Search V2?',
          articleURL: URL['KnowledgeBase1_01'],
          imageURL: knowledgeBase01,
          isVideo: true
        },
        {
          articleTitle: 'Get started with Boost Product Filter & Search',
          articleURL: URL['KnowledgeBase1_02'],
          imageURL: knowledgeBase02,
          isVideo: true
        },
        {
          articleTitle: 'Theme setup insights for Boost Product Filter & Search users',
          articleURL: URL['KnowledgeBase1_03'],
          imageURL: knowledgeBase03,
          isVideo: true
        }
      ]
    } = knowledgeGuide;

    const knowledgeBase = _.map(contents, item => ({
      src: item.imageURL,
      title: item.articleTitle,
      href: item.articleURL,
      isVideo: item.isVideo
    }));

    return (
      <div className="BC-KnowledgeBase__Dashboard">
        <Card>
          <Card.Header title={i18n.translate('AdminHTML.Dashboard.Common.guideToKnowledgeBase')}>
            <div className="BC-Block-Dismiss--Right-Menu">{renderPopover()}</div>
          </Card.Header>
          <Card.Section>
            <Layout>
              {knowledgeBase.map((item, index) => (
                <Layout.Section oneThird key={index}>
                  <div className="knowledgeBox">
                    <Card>
                      <button
                        onClick={e => {
                          this.handleOpenLink(e);
                        }}
                        data-url={item.href}
                        data-title={item.title}
                        data-is-video={item.isVideo}>
                        <img className="full-width" src={item.src} alt={item.title} />
                        <Card.Section>
                          <Caption>
                            <TextStyle variation="strong">
                              <span className="guide">{item.title}</span>
                            </TextStyle>
                          </Caption>
                        </Card.Section>
                      </button>
                    </Card>
                  </div>
                </Layout.Section>
              ))}
            </Layout>
          </Card.Section>
        </Card>
        <YoutubeModal
          active={youtubeModal !== null}
          {...youtubeModal}
          onClose={this.handleCloseYoutubeModal}
        />
      </div>
    );
  }

  handleOpenLink = e => {
    const { url, title, isVideo } = e.currentTarget.dataset;
    if (isVideo === 'true') {
      // Open video modal
      this.setState({
        youtubeModal: { embeddedURL: url, title }
      });
    } else {
      // Open link in new tab
      window.open(url, '_blank');
    }
  };

  handleCloseYoutubeModal = () => this.setState({ youtubeModal: null });
}

const mapStateToProps = (state, props) => {
  const knowledgeGuide = _.get(state.dashboard, 'dashboardComponents.knowledgeGuides.data', {});

  return { knowledgeGuide };
};

const mapDispatchToProps = dispatch => ({});

export default withBlockCanDismiss(
  connect(mapStateToProps, mapDispatchToProps)(withI18n()(GuideToKnowledgeBase))
);
